import serverDownBear from '../../images/serverDownBear.svg'


const ServerDown = () => {
  return (
    <img src={serverDownBear} className='error-bear' alt="Server Down 500 Error"></img>
  )
}

export default ServerDown